import { render, staticRenderFns } from "./showdata.vue?vue&type=template&id=01f0bf32&scoped=true&"
import script from "./showdata.vue?vue&type=script&lang=js&"
export * from "./showdata.vue?vue&type=script&lang=js&"
import style0 from "./showdata.vue?vue&type=style&index=0&id=01f0bf32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f0bf32",
  null
  
)

export default component.exports